import { ChangeDetectorRef, Component, ElementRef, Injectable, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { FieldService } from '../../../../../../common/services/Field.service';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { DefaultField, FieldConst, FieldType } from './properties.const';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';

declare var $: any;

@Component({
  selector: 'settings-contact-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.css'],
  providers: [FieldService],
})
@Injectable()
export class PropertiesComponent extends BaseListComponent {
  @ViewChild('template') template: ElementRef;
  public modelFilter: any = {};
  public allType: any = [];
  public data_options = [];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private fieldService: FieldService
  ) {
    super(changeDetector, toastr, modalService);
    this.allType = [{ id: '', text: 'Kiểu dữ liệu' }, ...FieldConst.FieldTypeArray()];
    this.displayColumns = FieldConst.displayColumns();
  }

  async ngOnInit() {
    await this.loadData();
  }

  setMessage(message: any) {
    this.message = message;
    setTimeout(() => {
      this.message = null;
    }, 3000);
    return;
  }

  async loadData(request: any = {}, sort: any = {}) {
    this.data = [];
    request.target = 'user';
    const payload = await this.buildBasePayload(request, sort);
    this.fieldService
      .list(payload)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            this.data = res.data.list;
            this.data.map(r => {
              r.display_type = FieldConst.FieldTypeTableString(r.type);
              return r;
            });
            this.initPage(res.data.total);
          } else {
            this.throwError();
          }
        },
        err => {
          this.throwError(err.message);
        }
      );
  }

  async search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      await this.loadData({
        title: this.modelFilter.keyword.trim(),
        target: 'user',
      });
    } else {
      await this.loadData();
    }
  }

  async setUpModel() {
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới thuộc tính người dùng' : 'Cập nhật thuộc tính người dùng',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'title',
        label: 'Tiêu đề thuộc tính',
        type: FormFieldType.Text,
        value: this.model.title,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'key',
        label: 'Key thuộc tính',
        type: FormFieldType.Text,
        value: this.model.key,
        required: true,
        disabled: false,
        width: 'full',
        order: 1,
      },
      {
        key: '_note',
        label: '',
        type: FormFieldType.Note,
        value: `<span class="mb-2 text-muted text-sm mt-1">Các key thuộc tính không được trùng với các key thuộc tính mặc định: ${DefaultField.join(', ')}</span>`,
        width: 'full',
        order: 2,
      },
      {
        key: 'type',
        label: 'Kiểu dữ liệu',
        type: FormFieldType.Select2,
        value: this.model.type,
        required: true,
        disabled: false,
        width: 'full',
        order: 3,
        options: {
          data: this.allType,
          select2Options: {
            placeholder: { id: '', text: 'Kiểu dữ liệu' },
          },
        },
      },
    ];
    let order = 4;
    if (this.model.type == FieldType.Select || this.model.type == FieldType.MultiSelect) {
      this.modelDisplay.push({
        key: 'label_option',
        label: 'Giá trị lựa chọn',
        value: '',
        width: 'full',
        order: order,
      });
      order++;
      for (let i = 1; i <= this.data_options.length; i++) {
        this.modelDisplay.push({
          key: 'data_option_' + i,
          label: 'Lựa chọn ' + i,
          type: FormFieldType.Text,
          value: this.model['data_option_' + i],
          required: true,
          disabled: false,
          remove: true,
          width: 'full',
          order: order,
          options: {
            checkInline: true,
          },
        });
        order++;
      }
      this.modelDisplay.push({
        key: 'btn_option',
        width: 'full',
        type: FormFieldType.CustomButton,
        order: order,
        options: {
          buttons: [
            {
              title: 'Thêm lựa chọn',
              width: '1/4',
              classes: 'btn btn-primary',
              value: 1,
            },
          ],
        },
      });
      order++;
    }
    this.modelDisplay.push({
      key: 'required',
      label: 'Bắt buộc',
      type: FormFieldType.Switch,
      value: this.model.required,
      required: false,
      disabled: false,
      width: 'full',
      order: order + 3,
      options: {
        checkInline: true,
      },
    });
  }

  async onChangeValueModel(key, item?: any) {
    this.model = _.merge({}, this.model, item);
    switch (key) {
      case 'type':
        if (item[key] !== FieldType.Select || item[key] !== FieldType.MultiSelect) {
          this.data_options = ['data_option_1'];
        }
        break;
      case 'btn_option':
        await this.addOption();
        break;
      case 'key':
        if (DefaultField.includes(item[key])) {
          return this.setMessage({
            class: 'alert dark alert-danger',
            content: 'Key thuộc tính trùng với các key giá trị mặc định. Vui lòng chọn key thuộc tính khác!',
          });
        } else if (!/^[A-Za-z_]+$/gi.test(item[key])) {
          return this.setMessage({
            class: 'alert dark alert-danger',
            content: "Key thuộc tính chỉ bao gồm chữ cái và dấu '_' !",
          });
        } else {
          this.message = null;
        }
        break;
      default:
        break;
    }
    await this.setUpModel();
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    const payload = {
      target: 'user',
      key: this.model.key ? this.model.key.trim().toLowerCase() : '',
      title: this.model.title ? this.model.title.trim() : '',
      type: this.model.type,
      required: this.model.required,
    };
    const data = [];
    Object.keys(this.model).forEach(key => {
      if (key.includes('data_option') && this.data_options.includes(key)) {
        data.push(this.model[key]);
      }
    });
    if (this.model.type === FieldType.Select || this.model.type === FieldType.MultiSelect) {
      const duplicateArray = data.map(e => e.trim()).filter((value, index, self) => self.indexOf(value) !== index);
      if (duplicateArray && duplicateArray.length > 0) {
        return this.setMessage({
          class: 'alert dark alert-danger',
          content: `Các giá trị trùng lặp: ${duplicateArray.join(', ')}`,
        });
      }
      payload['data'] = data;
    }

    const payloadFormat = {
      payloadFields: payload,
      payloadTemplatePermission: {},
    };
    if (this.typeModal === 'add') {
      await this.add(payloadFormat);
    } else if (this.typeModal === 'edit') {
      await this.edit(this.model._id, payloadFormat);
    }
  }

  async deleteOption(key) {
    delete this.model[key];
    this.data_options = this.data_options.filter(i => i !== key);
    await this.setUpModel();
  }

  async addOption() {
    const i = this.data_options.length + 1;
    this.data_options.push('data_option_' + i);
  }

  async edit(id, payload) {
    this.fieldService.update(id, payload).subscribe(
      res => {
        if (res.status === 200 && !res.error) {
          this.throwSuccess('Cập nhật thành công!');
          this.loadData();
          this.closeModal();
        } else {
          return this.setMessage({
            class: 'alert dark alert-danger',
            content: res.message,
          });
        }
      },
      error => {
        return this.setMessage({
          class: 'alert dark alert-danger',
          content: error.message,
        });
      }
    );
  }

  async add(payload) {
    this.fieldService.create(payload).subscribe(
      res => {
        if (res.status === 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          return this.setMessage({
            class: 'alert dark alert-danger',
            content: res.message,
          });
        }
      },
      error => {
        return this.setMessage({
          class: 'alert dark alert-danger',
          content: error.message,
        });
      }
    );
  }

  async openConfirmDelete() {
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDelete();
    }
  }

  async submitDelete() {
    this.fieldService._delete(this.delete_id).subscribe(
      res => {
        if (res.status === 200 && !res.error) {
          this.throwSuccess('Xóa thành công!');
          this.loadData();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async handleAction(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    switch (type) {
      case TableAction.add:
        this.typeModal = 'add';
        await this.setUpModel();
        this.openModal(this.template, config, null, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        Object.keys(item).forEach(key => {
          if (item[key] !== null && item[key] !== undefined) {
            this.model[key] = item[key];
            if (key === 'data') {
              this.data_options = [];
              for (let i = 1; i <= item[key].length; i++) {
                this.data_options.push('data_option_' + i);
                this.model['data_option_' + i] = item[key][i - 1];
              }
            }
          }
        });
        this.typeModal = 'edit';
        await this.setUpModel();
        this.openModal(this.template, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.delete:
        this.delete_id = item._id;
        await this.openConfirmDelete();
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/contact/properties/properties.component.ts